<section
  class="relative flex min-h-[calc(100svh-4.25rem)] items-center overflow-hidden bg-forest sm:block sm:min-h-0"
>
  <div class="pointer-events-none absolute inset-0" aria-hidden="true">
    <img
      src="assets/hero/saddle-close.webp"
      alt=""
      fetchpriority="high"
      class="absolute inset-0 h-full w-full scale-110 object-cover opacity-25 blur-sm"
    />
    <div
      class="absolute inset-0 bg-[radial-gradient(ellipse_90%_55%_at_50%_-15%,rgba(198,161,91,0.14),transparent_58%)]"
    ></div>
    <div
      class="absolute inset-0 bg-[radial-gradient(ellipse_70%_80%_at_50%_100%,rgba(20,33,26,0.55),transparent_65%)]"
    ></div>
    <div
      class="absolute inset-0 bg-[radial-gradient(ellipse_100%_100%_at_50%_40%,transparent_45%,rgba(20,33,26,0.35)_100%)]"
    ></div>
    <div class="hero-grain absolute inset-0 opacity-[0.04] mix-blend-overlay"></div>
  </div>

  <div
    class="relative mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-16 text-center sm:py-32"
    appReveal
  >
    <img
      src="assets/branding/icon-256-faded.webp"
      alt=""
      width="762"
      height="1024"
      class="absolute inset-0 mx-auto h-full max-h-[36rem] w-auto opacity-10"
    />
    <img
      src="assets/branding/icon-512.webp"
      alt="Galopa"
      width="381"
      height="512"
      class="relative h-28 w-auto sm:h-32"
    />
    <h1 class="relative mt-8 font-display text-4xl font-semibold text-cream sm:text-5xl">
      Beautifully kept saddles,<br class="hidden sm:block" />
      ready for their next rider.
    </h1>
    <p class="relative mt-4 max-w-xl text-tanlight">
      Trusted sellers. Secure transactions. Confident riders.
    </p>

    <div class="relative mt-8 flex flex-wrap items-center justify-center gap-4">
      <a
        [routerLink]="authService.isAuthenticated() ? '/account/listings/new' : '/join/FIRSTSALE'"
        class="rounded-full bg-cream px-6 py-3 text-sm font-medium text-forest transition hover:bg-tanlight"
      >
        Sell a Saddle
      </a>
      <a
        routerLink="/shop"
        class="rounded-full border border-cream/40 px-6 py-3 text-sm font-medium text-cream transition hover:border-cream"
      >
        Shop saddles
      </a>
    </div>

    <div class="relative mt-6 flex justify-center text-xs text-cream/60">
      <app-stripe-badge label="Powered by Stripe - secured payments" />
    </div>
  </div>
</section>

<section class="border-t border-cream/10 bg-forest text-cream">
  <div
    class="mx-auto grid max-w-7xl grid-cols-2 gap-x-4 gap-y-8 px-4 py-10 sm:gap-6 sm:px-6 sm:py-8 lg:grid-cols-4 lg:gap-8 lg:px-8"
  >
    @for (badge of trustBadges; track badge.title) {
      <div
        class="flex flex-col items-center gap-2.5 text-center sm:flex-row sm:items-start sm:gap-3 sm:text-left"
      >
        <span
          class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-cream/10 text-cream sm:h-11 sm:w-11"
        >
          <app-icon [name]="badge.icon" svgClass="h-[18px] w-[18px]" [strokeWidth]="2" />
        </span>
        <div class="min-w-0">
          <p class="text-sm font-semibold leading-snug text-cream text-balance">
            {{ badge.title }}
          </p>
          <p class="mt-0.5 text-xs leading-snug text-cream/65">{{ badge.subtitle }}</p>
        </div>
      </div>
    }
  </div>

  <div class="border-t border-cream/10 px-4 py-5 sm:px-6 lg:px-8">
    <div
      class="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center text-xs text-cream/55"
    >
      <span class="flex items-center gap-1.5">
        <app-icon name="lock" svgClass="h-3.5 w-3.5" [strokeWidth]="2" />
        256-bit SSL encryption
      </span>
      <span class="flex items-center gap-1.5">
        <app-icon name="shield" svgClass="h-3.5 w-3.5" [strokeWidth]="2" />
        PCI-DSS Level 1 certified
      </span>
      <app-stripe-badge label="Payments processed by Stripe" markClass="text-[#8b91ff]" />
    </div>
  </div>
</section>

<section class="bg-creamdark/60 py-20 sm:py-24" appReveal>
  <div
    class="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8"
  >
    <div class="order-2 lg:order-1">
      <div class="aspect-[4/5] overflow-hidden rounded-3xl">
        <img
          src="assets/sell/tack-room.webp"
          alt="A saddle resting on a rack, unused"
          loading="lazy"
          class="h-full w-full object-cover"
        />
      </div>
    </div>

    <div class="order-1 lg:order-2">
      <p class="mb-3 text-sm font-medium uppercase tracking-wide text-tandark">For sellers</p>
      <h2 class="font-display text-3xl font-semibold text-ink sm:text-4xl">
        That saddle isn't doing anyone any good in the tack room.
      </h2>
      <p class="mt-4 max-w-lg text-ink/70">
        List it in minutes, free of charge, and put it in front of riders who are actually looking
        for exactly what you're selling.
      </p>

      <a
        routerLink="/join/FIRSTSALE"
        class="mt-6 flex max-w-lg items-center gap-3 rounded-2xl border border-rose/30 bg-rose/10 px-5 py-4 transition duration-300 hover:border-rose/50 hover:bg-rose/15"
      >
        <span
          class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rose text-cream"
        >
          <app-icon name="sparkle" svgClass="h-4 w-4" [strokeWidth]="1.75" />
        </span>
        <span>
          <span class="block text-sm font-semibold text-ink">
            Founding Seller offer - 3% commission, save 5%
          </span>
          <span class="block text-xs text-ink/60">
            On your first 3 sales. Limited to our first 100 sellers - claim your spot &rarr;
          </span>
        </span>
      </a>

      <div class="mt-8 flex flex-col gap-4">
        <div
          class="flex items-center gap-4 rounded-2xl border border-line bg-white px-5 py-4 transition duration-300 hover:-translate-y-0.5 hover:shadow-lg"
        >
          <span
            class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-forest/10 text-forest"
          >
            <app-icon name="tag" svgClass="h-5 w-5" [strokeWidth]="1.5" />
          </span>
          <div>
            <p class="font-semibold text-ink">Free to list</p>
            <p class="text-sm text-ink/60">
              No listing fees, ever - we only take a cut once your saddle sells.
            </p>
          </div>
        </div>
        <div
          class="flex items-center gap-4 rounded-2xl border border-line bg-white px-5 py-4 transition duration-300 hover:-translate-y-0.5 hover:shadow-lg"
        >
          <span
            class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-forest/10 text-forest"
          >
            <app-icon name="shield" svgClass="h-5 w-5" [strokeWidth]="1.5" />
          </span>
          <div>
            <p class="font-semibold text-ink">Verified buyers</p>
            <p class="text-sm text-ink/60">
              Every buyer checks out through Galopa - no chasing payment yourself.
            </p>
          </div>
        </div>
        <div
          class="flex items-center gap-4 rounded-2xl border border-line bg-white px-5 py-4 transition duration-300 hover:-translate-y-0.5 hover:shadow-lg"
        >
          <span
            class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-forest/10 text-forest"
          >
            <app-icon name="lock" svgClass="h-5 w-5" [strokeWidth]="1.5" />
          </span>
          <div>
            <p class="font-semibold text-ink">Secured before you ship</p>
            <p class="text-sm text-ink/60">
              The moment a sale is accepted, the buyer's payment is already secured by Stripe - so
              you can ship anywhere in the country with total confidence, no chasing payment after
              the fact.
            </p>
          </div>
        </div>
      </div>

      <div class="mt-8">
        @if (authService.isAuthenticated()) {
          <a
            routerLink="/account/listings/new"
            class="inline-block rounded-full bg-forest px-7 py-3.5 text-sm font-medium text-cream transition hover:bg-forestdark"
          >
            List your saddle
          </a>
        } @else {
          <a
            routerLink="/join/FIRSTSALE"
            class="inline-block rounded-full bg-forest px-7 py-3.5 text-sm font-medium text-cream transition hover:bg-forestdark"
          >
            Claim your founding seller offer
          </a>
        }
      </div>
    </div>
  </div>
</section>

<section class="px-4 py-20 sm:px-6 sm:py-24 lg:px-8" appReveal>
  <div
    class="mx-auto grid max-w-6xl grid-cols-1 overflow-hidden rounded-3xl border border-line bg-white lg:grid-cols-2"
  >
    <div class="relative min-h-[16rem] overflow-hidden lg:min-h-0">
      <img
        src="assets/marketing/secure-trade-highway.webp"
        alt="A courier van on a long rural Australian highway at golden hour"
        loading="lazy"
        class="absolute inset-0 h-full w-full object-cover"
      />
      <div
        class="absolute inset-0 bg-gradient-to-t from-ink/50 to-ink/10 lg:bg-gradient-to-r lg:from-transparent lg:to-ink/20"
      ></div>
    </div>
    <div class="p-8 sm:p-12">
      <p class="mb-3 text-sm font-medium uppercase tracking-wide text-tandark">
        Shipping a saddle?
      </p>
      <h2 class="font-display text-3xl font-semibold text-ink sm:text-4xl">
        See approximate shipping costs before you commit.
      </h2>
      <p class="mt-4 text-ink/70">
        Enter a from and to postcode and we'll estimate the cost to box and post a saddle anywhere
        in Australia - based on a live Australia Post quote.
      </p>

      <div class="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div>
          <p class="font-semibold text-ink">Australia-wide</p>
          <p class="mt-1 text-sm leading-relaxed text-ink/60">Any postcode to any postcode.</p>
        </div>
        <div>
          <p class="font-semibold text-ink">Approximate estimate</p>
          <p class="mt-1 text-sm leading-relaxed text-ink/60">
            Not a fixed price - actual cost may vary.
          </p>
        </div>
        <div>
          <p class="font-semibold text-ink">Australia Post rates</p>
          <p class="mt-1 text-sm leading-relaxed text-ink/60">
            A live quote, the same engine as checkout.
          </p>
        </div>
      </div>

      <a
        routerLink="/shipping-calculator"
        class="mt-8 inline-flex items-center gap-1.5 rounded-full bg-ink px-7 py-3.5 text-sm font-medium text-cream transition hover:opacity-90"
      >
        Estimate shipping cost
        <app-icon name="arrowRight" svgClass="h-4 w-4" [strokeWidth]="2" />
      </a>
    </div>
  </div>
</section>

<section class="mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8" appReveal>
  <div class="mb-10 flex flex-wrap items-end justify-between gap-4">
    <div>
      <p class="mb-3 text-sm font-medium uppercase tracking-wide text-tandark">
        Shop by discipline
      </p>
      <h2 class="font-display text-3xl font-semibold text-ink sm:text-4xl">
        Find the fit for your sport
      </h2>
    </div>
    <a routerLink="/shop" class="hidden text-sm font-medium text-forest hover:underline sm:inline"
      >View all saddles &rarr;</a
    >
  </div>

  <div class="grid grid-cols-2 gap-x-3 gap-y-6 sm:gap-x-5 sm:gap-y-8 lg:grid-cols-4 lg:gap-x-6">
    @for (category of categoryTiles; track category.slug) {
      <a
        [routerLink]="['/shop']"
        [queryParams]="{ discipline: category.slug }"
        class="group flex flex-col"
      >
        <div
          class="relative aspect-square overflow-hidden rounded-2xl border border-line bg-creamdark transition duration-300 group-hover:border-forest/30 group-hover:shadow-lg"
        >
          <div
            class="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_100%,rgba(30,46,35,0.06),transparent_70%)]"
            aria-hidden="true"
          ></div>
          <div class="relative flex h-full items-center justify-center p-4 sm:p-6">
            <img
              [src]="category.image"
              [alt]="category.label + ' saddle'"
              loading="lazy"
              class="max-h-full max-w-full object-contain transition duration-500 ease-out group-hover:scale-[1.04]"
            />
          </div>
        </div>
        <span class="mt-3 flex flex-col items-center gap-2.5 sm:mt-3.5 sm:gap-3">
          <span class="block h-px w-8 bg-line" aria-hidden="true"></span>
          <span
            class="text-center font-display text-[0.8125rem] font-medium tracking-wide text-ink sm:text-base"
          >
            {{ category.label }}
          </span>
        </span>
      </a>
    }
  </div>
</section>

<section id="safety" class="relative overflow-hidden bg-forest py-24 text-cream sm:py-28" appReveal>
  <div
    class="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8"
  >
    <div>
      <p class="mb-4 flex items-center gap-3 text-sm font-medium uppercase tracking-wide text-gold">
        <!-- <span class="h-px w-4 bg-gold"></span> -->
        Zero-risk guarantee
      </p>
      <h2 class="font-display text-3xl font-semibold leading-tight text-cream sm:text-5xl">
        Buying secondhand shouldn't feel like a gamble.
      </h2>
      <p class="mb-10 mt-6 max-w-lg text-base text-cream/80 sm:text-lg">
        Every payment on Galopa is protected until you're sure - your money stays safely held, never
        released to the seller until everything checks out. And if it's ever not the right fit,
        you're not stuck: relist it in minutes, completely free.
      </p>

      <div class="flex flex-col gap-7">
        <div class="flex gap-5">
          <span
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold font-display font-semibold text-forestdark"
            >1</span
          >
          <div>
            <p class="mb-1 font-semibold text-cream">Buy with confidence</p>
            <p class="text-sm text-cream/70">
              Pay securely - your funds stay protected until you confirm you're happy.
            </p>
          </div>
        </div>
        <div class="flex gap-5">
          <span
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold font-display font-semibold text-forestdark"
            >2</span
          >
          <div>
            <p class="mb-1 font-semibold text-cream">Inspect it at home</p>
            <p class="text-sm text-cream/70">
              Check it on your own horse. Confirm it matches the listing before funds release.
            </p>
          </div>
        </div>
        <div class="flex gap-5">
          <span
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold font-display font-semibold text-forestdark"
            >3</span
          >
          <div>
            <p class="mb-1 font-semibold text-cream">Keep it, or relist it</p>
            <p class="text-sm text-cream/70">
              Not the right fit? Relist it in minutes - completely free.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="relative">
      <div class="aspect-[4/5] overflow-hidden rounded-3xl">
        <img
          src="assets/trial/home-trial.webp"
          alt="Saddle resting on a fence rail at home"
          loading="lazy"
          class="h-full w-full object-cover"
        />
      </div>
      <div
        class="absolute -bottom-6 -left-6 hidden max-w-[240px] rounded-2xl bg-cream p-5 text-ink shadow-2xl sm:block"
      >
        <p class="font-display text-2xl text-forest">$0</p>
        <p class="mt-1 text-sm text-ink/70">to relist if it's not the right fit - always free.</p>
      </div>
    </div>
  </div>
</section>

<section id="how-it-works" class="px-4 py-20 sm:px-6 sm:py-24 lg:px-8" appReveal>
  <div class="mx-auto max-w-6xl">
    <div class="mx-auto max-w-2xl text-center">
      <p class="mb-3 text-sm font-medium uppercase tracking-wide text-tandark">Simple by design</p>
      <h2 class="font-display text-3xl font-semibold text-ink sm:text-4xl">How It Works</h2>
      <p class="mt-4 text-ink/70">
        Whether you're buying or selling, the path is short, clear, and protected end to end.
      </p>
    </div>

    <div class="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
      <article
        class="flex flex-col overflow-hidden rounded-3xl border border-line bg-white transition duration-300 hover:shadow-lg"
      >
        <div class="aspect-[16/9] overflow-hidden bg-creamdark">
          <img
            src="assets/marketing/buy-hero.webp"
            alt="A leather saddle in a sunlit tack room"
            loading="lazy"
            class="h-full w-full object-cover"
          />
        </div>
        <div class="flex flex-1 flex-col p-6 sm:p-8">
          <p class="text-sm font-medium uppercase tracking-wide text-tandark">For buyers</p>
          <h3 class="mt-1 font-display text-2xl font-semibold text-ink sm:text-3xl">Buying</h3>

          <ol class="mt-8 flex flex-col gap-6">
            <li class="flex gap-4">
              <span
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-forest font-display text-sm font-semibold text-cream"
                >1</span
              >
              <div>
                <p class="font-semibold text-ink">Browse &amp; message</p>
                <p class="mt-1 text-sm leading-relaxed text-ink/70">
                  Explore verified listings and chat with sellers directly on Galopa.
                </p>
              </div>
            </li>
            <li class="flex gap-4">
              <span
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-forest font-display text-sm font-semibold text-cream"
                >2</span
              >
              <div>
                <p class="font-semibold text-ink">Pay securely</p>
                <p class="mt-1 text-sm leading-relaxed text-ink/70">
                  Checkout with Payment Protection - your funds stay held until you're sure.
                </p>
              </div>
            </li>
            <li class="flex gap-4">
              <span
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-forest font-display text-sm font-semibold text-cream"
                >3</span
              >
              <div>
                <p class="font-semibold text-ink">Inspect it at home</p>
                <p class="mt-1 text-sm leading-relaxed text-ink/70">
                  Check the fit on your own horse. Not the right one? Relist it for free.
                </p>
              </div>
            </li>
          </ol>

          <a
            routerLink="/shop"
            class="mt-8 block w-full rounded-full bg-forest px-5 py-3 text-center text-sm font-medium text-cream transition hover:bg-forestdark sm:mt-10"
          >
            Shop saddles
          </a>
        </div>
      </article>

      <article
        id="sell"
        class="flex flex-col overflow-hidden rounded-3xl border border-line bg-white transition duration-300 hover:shadow-lg"
      >
        <div class="aspect-[16/9] overflow-hidden bg-creamdark">
          <img
            src="assets/marketing/sell-hero.webp"
            alt="A western saddle resting on a fence rail at golden hour"
            loading="lazy"
            class="h-full w-full object-cover"
          />
        </div>
        <div class="flex flex-1 flex-col p-6 sm:p-8">
          <p class="text-sm font-medium uppercase tracking-wide text-tandark">For sellers</p>
          <h3 class="mt-1 font-display text-2xl font-semibold text-ink sm:text-3xl">Selling</h3>

          <ol class="mt-8 flex flex-col gap-6">
            <li class="flex gap-4">
              <span
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rose font-display text-sm font-semibold text-cream"
                >1</span
              >
              <div>
                <p class="font-semibold text-ink">List for free</p>
                <p class="mt-1 text-sm leading-relaxed text-ink/70">
                  Add your saddle in a few minutes - no listing fees to get started.
                </p>
              </div>
            </li>
            <li class="flex gap-4">
              <span
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rose font-display text-sm font-semibold text-cream"
                >2</span
              >
              <div>
                <p class="font-semibold text-ink">Chat with buyers</p>
                <p class="mt-1 text-sm leading-relaxed text-ink/70">
                  Answer questions and agree details with interested riders on Galopa.
                </p>
              </div>
            </li>
            <li class="flex gap-4">
              <span
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rose font-display text-sm font-semibold text-cream"
                >3</span
              >
              <div>
                <p class="font-semibold text-ink">Get paid</p>
                <p class="mt-1 text-sm leading-relaxed text-ink/70">
                  Funds release to you once the buyer confirms everything checks out.
                </p>
              </div>
            </li>
          </ol>

          @if (authService.isAuthenticated()) {
            <a
              routerLink="/account/listings/new"
              class="mt-8 block w-full rounded-full bg-rose px-5 py-3 text-center text-sm font-medium text-cream transition hover:opacity-90 sm:mt-10"
            >
              Sell a saddle
            </a>
          } @else {
            <a
              routerLink="/signup"
              class="mt-8 block w-full rounded-full bg-rose px-5 py-3 text-center text-sm font-medium text-cream transition hover:opacity-90 sm:mt-10"
            >
              Sign up to sell
            </a>
          }
        </div>
      </article>
    </div>
  </div>
</section>

<section class="bg-creamdark/50 px-4 py-20 sm:px-6 sm:py-24 lg:px-8" appReveal>
  <div class="mx-auto max-w-6xl">
    <div class="mx-auto max-w-2xl text-center">
      <p class="mb-3 text-sm font-medium uppercase tracking-wide text-tandark">Other ways in</p>
      <h2 class="font-display text-3xl font-semibold text-ink sm:text-4xl">
        The shop isn't the only starting point.
      </h2>
    </div>

    <div class="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div class="overflow-hidden rounded-3xl border border-line bg-white">
        <div class="aspect-[16/9] overflow-hidden">
          <img
            src="assets/marketing/secure-trade-agree.webp"
            alt="A rider outdoors on her phone, agreeing a remote saddle deal"
            loading="lazy"
            class="h-full w-full object-cover"
          />
        </div>
        <div class="p-8 sm:p-10">
          <p class="text-sm font-medium uppercase tracking-wide text-tandark">Already found it?</p>
          <h3 class="mt-2 font-display text-2xl font-semibold text-ink">
            Bring an off-platform deal onto Galopa.
          </h3>
          <p class="mt-3 text-ink/70">
            Found a saddle on Facebook Marketplace or a noticeboard? Start a Secure Trade — we hold
            the payment until it arrives as described, anywhere in Australia.
          </p>
          <a
            routerLink="/secure-trade"
            class="mt-6 inline-flex items-center gap-1.5 rounded-full bg-forest px-6 py-3 text-sm font-medium text-cream transition hover:bg-forestdark"
          >
            How Secure Trade works
            <app-icon name="arrowRight" svgClass="h-4 w-4" [strokeWidth]="2" />
          </a>
        </div>
      </div>

      <div class="overflow-hidden rounded-3xl border border-line bg-white">
        <div class="aspect-[16/9] overflow-hidden">
          <img
            src="assets/marketing/wanted-hero.webp"
            alt="A western saddle and coiled rope, waiting"
            loading="lazy"
            class="h-full w-full object-cover"
          />
        </div>
        <div class="p-8 sm:p-10">
          <p class="text-sm font-medium uppercase tracking-wide text-tandark">Reverse the search</p>
          <h3 class="mt-2 font-display text-2xl font-semibold text-ink">
            Not finding the saddle you want?
          </h3>
          <p class="mt-3 text-ink/70">
            Post a Wanted Saddle — brand, size, tree width, budget — and let sellers with a match
            come to you.
          </p>
          <a
            routerLink="/wanted"
            class="mt-6 inline-flex items-center gap-1.5 rounded-full bg-ink px-6 py-3 text-sm font-medium text-cream transition hover:opacity-90"
          >
            Explore Wanted Saddle
            <app-icon name="arrowRight" svgClass="h-4 w-4" [strokeWidth]="2" />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="px-4 py-20 sm:px-6 sm:py-24 lg:px-8" appReveal>
  <div class="mx-auto max-w-7xl">
    <div class="mx-auto mb-14 max-w-2xl text-center">
      <p class="mb-3 text-sm font-medium uppercase tracking-wide text-tandark">Trusted by riders</p>
      <h2 class="font-display text-3xl font-semibold text-ink sm:text-4xl">
        Loved by buyers and sellers alike
      </h2>
    </div>
    <app-snap-carousel
      [count]="testimonials.length"
      trackClass="md:grid md:grid-cols-3 md:gap-6 md:overflow-visible"
      dotsClass="mt-6 md:hidden"
      ariaLabel="Reviews"
      dotLabel="Show review"
    >
      @for (t of testimonials; track t.name) {
        <div class="w-full shrink-0 snap-start px-1 md:w-auto md:px-0">
          <div
            class="h-full rounded-2xl border border-line bg-white p-7 transition duration-300 hover:shadow-lg"
          >
            <app-star-rating rating="5" class="mb-4 block" />
            <p class="mb-5 text-sm text-ink/80">&ldquo;{{ t.quote }}&rdquo;</p>
            <p class="text-sm font-semibold text-ink">{{ t.name }}</p>
          </div>
        </div>
      }
    </app-snap-carousel>
  </div>
</section>

<section class="px-4 py-20 sm:px-6 sm:py-24 lg:px-8" appReveal>
  <div class="mx-auto max-w-3xl">
    <div class="mx-auto mb-12 max-w-2xl text-center">
      <p class="mb-3 text-sm font-medium uppercase tracking-wide text-tandark">Questions</p>
      <h2 class="font-display text-3xl font-semibold text-ink sm:text-4xl">Frequently asked</h2>
    </div>

    <div class="divide-y divide-line rounded-3xl border border-line bg-white">
      @for (item of faqs; track item.question; let i = $index) {
        <div>
          <button
            type="button"
            class="flex w-full cursor-pointer items-center justify-between gap-4 px-6 py-5 text-left"
            [attr.aria-expanded]="openFaqIndex() === i"
            (click)="toggleFaq(i)"
          >
            <span class="font-medium text-ink">{{ item.question }}</span>
            <app-icon
              name="plus"
              [svgClass]="
                'h-4 w-4 shrink-0 text-tandark transition duration-300' +
                (openFaqIndex() === i ? ' rotate-45' : '')
              "
              [strokeWidth]="2"
            />
          </button>
          @if (openFaqIndex() === i) {
            <p
              class="px-6 pb-5 text-sm leading-relaxed text-ink/70 [&_a]:font-medium [&_a]:text-forest [&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:text-forestdark"
              [innerHTML]="item.answer"
            ></p>
          }
        </div>
      }
    </div>

    <p class="mt-8 text-center text-sm text-ink/60">
      More questions?
      <a routerLink="/help" class="font-medium text-forest hover:underline"
        >Visit the Help centre &rarr;</a
      >
    </p>
  </div>
</section>

<section class="relative overflow-hidden bg-forest py-20 text-cream sm:py-24" appReveal>
  <img
    src="assets/marketing/secure-trade-hero.webp"
    alt=""
    class="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-25"
  />
  <div class="absolute inset-0 bg-forest/70"></div>
  <div class="relative mx-auto max-w-2xl px-4 text-center sm:px-6 lg:px-8">
    <p class="mb-3 text-sm font-medium uppercase tracking-wide text-gold">Stay in the loop</p>
    <h2 class="mb-4 font-display text-3xl font-semibold text-cream sm:text-4xl">
      Never miss a saddle - or a buyer
    </h2>
    <p class="mb-8 text-cream/70">
      Buying? Be first to hear about new listings. Selling? We'll let you know when a rider posts a
      Wanted Saddle that matches what you've got.
    </p>

    @if (subscribed()) {
      <p class="font-medium text-gold">You're subscribed - welcome to the herd!</p>
    } @else {
      <form class="mx-auto flex max-w-md flex-col gap-3 sm:flex-row" (submit)="subscribe($event)">
        <input
          type="email"
          required
          placeholder="you@example.com"
          autocomplete="email"
          class="flex-1 rounded-full border border-cream/20 bg-cream px-5 py-3.5 text-sm text-ink placeholder:text-ink/40 focus:outline-none focus:ring-2 focus:ring-gold/50"
          [value]="newsletterEmail()"
          [disabled]="subscribePending()"
          (input)="newsletterEmail.set($any($event.target).value); subscribeError.set(null)"
        />
        <button
          type="submit"
          class="cursor-pointer rounded-full bg-cream px-6 py-3.5 text-sm font-medium text-forest transition hover:bg-tanlight disabled:opacity-60"
          [disabled]="subscribePending()"
        >
          {{ subscribePending() ? 'Subscribing…' : 'Subscribe' }}
        </button>
      </form>
      @if (subscribeError()) {
        <p class="mt-3 text-sm text-roselight">{{ subscribeError() }}</p>
      }
    }
  </div>
</section>
